import React from "react";
import ExecutiveForm from "./ExecutiveForm";

export default function ViewExecutive() {
    return (
        <ExecutiveForm type="VIEW" />
    );
}
